(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.HeaderView = (function(superClass) {
    extend(HeaderView, superClass);

    function HeaderView() {
      return HeaderView.__super__.constructor.apply(this, arguments);
    }

    HeaderView.prototype.events = {
      "click .search-toggle-button": "toggleSearch",
      "change .shop-by-category, .shop-by-vendor": "fireSearchSelect",
      "click .main-nav .dropdown > a": "toggleMenu",
      "click .main-nav .dropdown.mega": "positionMegaNav",
      "click .main-nav .dropdown.mega li[data-expandable='true']": "determineNavAction",
      "click .mobile-nav-dropdown-container .dropdown > a": "toggleMobileNavTier",
      "click .sub-nav li[data-expandable='true'] > a": "toggleMobileMegaNavTier",
      "click .mobile-nav-item.navigate > a": "toggleMobileNav",
      "click .mobile-nav-item.browse > a": "toggleMobileNav"
    };

    HeaderView.prototype.initialize = function() {
      this.body = $(document.body);
      this.headerNav = this.$(".header-nav");
      if (this.$(".mega.dropdown")) {
        this.megaDropdown = this.$(".mega .dropdown-nav");
        this.megaDropdownHeader = this.$(".mega.dropdown .dropdown-nav header");
        this.primaryPanel = this.$(".primary-nav-level");
        this.secondaryPanel = this.$(".secondary-nav-level");
        this.tertiaryPanel = this.$(".tertiary-nav-level");
        this.allPanels = this.primaryPanel.add(this.secondaryPanel).add(this.tertiaryPanel).add(this.$(".brands-nav-level"));
        this.subNavContents = this.primaryPanel.html();
        this.browseSearchPopup = this.$(".search-browse-container");
      }
      this.initializeNav();
      this.adjustSimpleNavPosition();
      $(window).resize((function(_this) {
        return function() {
          if (document.documentElement.offsetWidth >= 768 && _this.headerNav.hasClass("mobile-nav")) {
            _this.headerNav.addClass("main-nav").removeClass("mobile-nav");
            return _this.setupDesktopNav();
          } else if (document.documentElement.offsetWidth < 768 && _this.headerNav.hasClass("main-nav")) {
            _this.headerNav.addClass("mobile-nav").removeClass("main-nav");
            return _this.setupMobileNav();
          }
        };
      })(this)).trigger("resize");
      $(document.body).on("click", (function(_this) {
        return function(e) {
          if (!_this.$(e.target).closest(".search-toggle-button").length) {
            return _this.$(".search-toggle-button").removeClass("open");
          }
        };
      })(this));
      return this.transitionend = (function(transition) {
        var transEndEventNames;
        transEndEventNames = {
          "-webkit-transition": "webkitTransitionEnd",
          "-moz-transition": "transitionend",
          transition: "transitionend"
        };
        return transEndEventNames[transition];
      })(Modernizr.prefixed("transition"));
    };

    HeaderView.prototype.initializeNav = function() {
      var i, len, panel, ref, results;
      this.$(".secondary-list").appendTo(this.secondaryPanel);
      this.$(".tertiary-list").appendTo(this.tertiaryPanel);
      ref = this.allPanels.find("ul");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        panel = ref[i];
        panel = $(panel);
        if (panel.find("li").length > 5) {
          results.push(panel.find("li:last-child a").css("border-bottom", "0px"));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    HeaderView.prototype.setupDesktopNav = function() {
      this.headerNav.append($(".nav-item"));
      this.browseSearchPopup.removeClass("mobile").appendTo(this.$(".search-browse-parent-outline"));
      this.$(".sub-nav").remove();
      this.$(".dropdown > a > .arrow").removeClass("mobile").html("[");
      return this.initializeNav();
    };

    HeaderView.prototype.setupMobileNav = function() {
      var browseButton, megaNavItem, mobileBrowseContainer, mobileNavDropdownContainer, mobileNavItems, navigateButton;
      mobileBrowseContainer = this.$(".mobile-browse-container");
      mobileNavDropdownContainer = this.$(".mobile-nav-dropdown-container");
      mobileNavItems = this.$(".mobile-nav-item");
      browseButton = mobileNavItems.filter(".browse");
      navigateButton = mobileNavItems.filter(".navigate");
      megaNavItem = this.$(".dropdown.mega");
      mobileBrowseContainer.append(this.browseSearchPopup);
      this.browseSearchPopup.addClass("mobile");
      mobileNavDropdownContainer.append($("<ul class='dropdown-nav dropdown-nav-mega'>").append($(".nav-item")));
      if (this.$(".primary-nav-level li[data-expandable]").length) {
        mobileNavDropdownContainer.find(".nav-item.mega").after($("<li class='sub-nav'>").append(this.subNavContents));
      }
      return this.$(".dropdown > a > .arrow").add(".sub-nav .arrow").addClass("mobile").html("]");
    };

    HeaderView.prototype.toggleSearch = function(e) {
      console.log("toggle");
      if (this.$(".search-toggle-button").hasClass("open") && this.$(e.target).hasClass("search-browse-parent-outline")) {
        return this.$(".search-toggle-button").removeClass("open");
      } else {
        this.$(".search-browse-container").css({
          top: $(".search-browse-parent-outline").height()
        });
        return this.$(".search-toggle-button").addClass("open");
      }
    };

    HeaderView.prototype.fireSearchSelect = function(e) {
      var target;
      target = this.$(e.target);
      if (target.val().length) {
        return window.location = target.val();
      }
    };

    HeaderView.prototype.toggleMenu = function(e) {
      var dropdown;
      e.preventDefault();
      dropdown = this.$(e.target).closest(".dropdown");
      if (!this.$(e.target).closest(".dropdown-nav").length) {
        this.$(".dropdown").not(dropdown).removeClass("active");
        return dropdown.toggleClass("active");
      }
    };

    HeaderView.prototype.adjustSimpleNavPosition = function() {
      var dropdown, dropdownWidth, i, leftPosition, len, navWidth, ref, results;
      navWidth = this.headerNav.width();
      ref = this.headerNav.children(".dropdown");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        dropdown = ref[i];
        dropdown = $(dropdown);
        leftPosition = dropdown.position().left;
        dropdownWidth = dropdown.find(".dropdown-nav").width();
        if ((navWidth - leftPosition) < dropdownWidth) {
          results.push(dropdown.not(".mega").find(".dropdown-nav").addClass("adjust-right"));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    HeaderView.prototype.positionMegaNav = function() {
      var containerHeight, heightCompensation, i, len, megaDropdownHeaderHeight, panel, ref, topOffset;
      heightCompensation = this.body.hasClass("minimalist") ? 2 : 1;
      topOffset = this.$(".mega.dropdown").outerHeight() - heightCompensation;
      megaDropdownHeaderHeight = this.megaDropdownHeader.outerHeight();
      containerHeight = 0;
      ref = this.megaDropdown.find("ul");
      for (i = 0, len = ref.length; i < len; i++) {
        panel = ref[i];
        panel = $(panel);
        if (panel.outerHeight() > containerHeight) {
          containerHeight = panel.outerHeight();
        }
      }
      this.megaDropdown.css({
        top: topOffset,
        height: megaDropdownHeaderHeight + containerHeight
      });
      return this.allPanels.css({
        height: containerHeight
      }).find("ul").css({
        height: containerHeight
      });
    };

    HeaderView.prototype.determineNavAction = function(e) {
      var dropdownBreadcrumbs, dropdownTitles, secondaryBreadcrumb, target, targetIsSelected, targetList, targetPanel, targetText, tertiaryBreadcrumb;
      e.preventDefault();
      target = $(e.target).closest("li[data-expandable='true']");
      targetIsSelected = target.hasClass("active");
      targetPanel = target.data("list-level");
      targetText = target.find("a").text();
      targetList = target.data("parent");
      targetList = this.$("ul[data-child='" + targetList + "']");
      dropdownTitles = this.$(".dropdown-titles");
      dropdownBreadcrumbs = this.$(".dropdown-breadcrumbs");
      secondaryBreadcrumb = dropdownBreadcrumbs.children(".secondary");
      tertiaryBreadcrumb = dropdownBreadcrumbs.children(".tertiary");
      if (targetIsSelected) {
        target.removeClass("active");
        target.siblings().removeClass("disabled");
      } else {
        target.addClass("active").removeClass("disabled");
        target.siblings().removeClass("active").addClass("disabled");
      }
      if (targetPanel === 2 && !this.secondaryPanel.hasClass("active") && !this.tertiaryPanel.hasClass("active")) {
        this.toggleSecondaryPanel();
        this.displayTargetList(targetList, this.secondaryPanel);
        dropdownTitles.removeClass("visible");
        dropdownBreadcrumbs.addClass("visible");
        secondaryBreadcrumb.addClass("visible").find(".label").text(targetText);
      }
      if (targetPanel === 2 && !targetIsSelected && this.secondaryPanel.hasClass("active") && !this.tertiaryPanel.hasClass("active")) {
        this.displayTargetList(targetList, this.secondaryPanel);
        secondaryBreadcrumb.find(".label").text(targetText);
      }
      if (targetPanel === 2 && targetIsSelected && !this.tertiaryPanel.hasClass("active")) {
        this.toggleSecondaryPanel();
        dropdownTitles.addClass("visible");
        dropdownBreadcrumbs.removeClass("visible");
      }
      if (targetPanel === 3 && !this.tertiaryPanel.hasClass("active")) {
        this.toggleTertiaryPanel();
        this.displayTargetList(targetList, this.tertiaryPanel);
        tertiaryBreadcrumb.addClass("visible").find(".label").text(targetText);
      }
      if (targetPanel === 3 && !targetIsSelected && this.tertiaryPanel.hasClass("active")) {
        this.displayTargetList(targetList, this.tertiaryPanel);
        tertiaryBreadcrumb.find(".label").text(targetText);
      }
      if (targetPanel === 3 && targetIsSelected && this.tertiaryPanel.hasClass("active")) {
        this.toggleTertiaryPanel();
        tertiaryBreadcrumb.removeClass("visible");
      }
      if (targetPanel === 2 && targetIsSelected && this.tertiaryPanel.hasClass("active")) {
        this.closeAllPanels();
        dropdownTitles.addClass("visible");
        dropdownBreadcrumbs.removeClass("visible");
        tertiaryBreadcrumb.removeClass("visible");
      }
      if (targetPanel === 2 && !targetIsSelected && this.tertiaryPanel.hasClass("active")) {
        this.toggleTertiaryPanel();
        this.secondaryPanel.find("li").removeClass("active");
        this.displayTargetList(targetList, this.secondaryPanel);
        secondaryBreadcrumb.find(".label").text(targetText);
        return tertiaryBreadcrumb.removeClass("visible");
      }
    };

    HeaderView.prototype.displayTargetList = function(targetList, panel) {
      targetList.css("z-index", "1000");
      return panel.find("ul").not(targetList).css("z-index", "1");
    };

    HeaderView.prototype.toggleSecondaryPanel = function() {
      return this.secondaryPanel.toggleClass("active left-half");
    };

    HeaderView.prototype.toggleTertiaryPanel = function() {
      this.primaryPanel.toggleClass("width-half width-third");
      this.secondaryPanel.toggleClass("left-third width-third left-half width-half");
      return this.tertiaryPanel.toggleClass("active left-two-thirds width-half width-third");
    };

    HeaderView.prototype.closeAllPanels = function() {
      this.tertiaryPanel.toggleClass("active left-two-thirds width-half width-third");
      this.secondaryPanel.toggleClass("left-third width-third left-half width-half").one(this.transitionend, (function(_this) {
        return function() {
          _this.secondaryPanel.toggleClass("active left-half");
          return _this.secondaryPanel.find("li").removeClass("active");
        };
      })(this));
      return this.primaryPanel.toggleClass("width-half width-third");
    };

    HeaderView.prototype.toggleMobileNav = function(e) {
      var navItem, target;
      navItem = this.$(".mobile-nav-item");
      target = $(e.target).closest(navItem);
      if (navItem.hasClass("active") && !target.hasClass("active")) {
        target.toggleClass("active").removeClass("fade");
        navItem.not(target).addClass("fade").removeClass("active");
        return this.$(".mobile-nav-dropdown-container").add(".mobile-browse-container").toggleClass("active");
      } else {
        target.toggleClass("active");
        navItem.not(target).toggleClass("fade");
        if (target.hasClass("navigate")) {
          return this.$(".mobile-nav-dropdown-container").toggleClass("active");
        } else if (target.hasClass("browse")) {
          return this.$(".mobile-browse-container").toggleClass("active");
        }
      }
    };

    HeaderView.prototype.toggleMobileNavTier = function(e) {
      var target;
      e.preventDefault();
      target = $(e.target).parent();
      if (!target.hasClass("mega")) {
        target.find(".dropdown-nav").addClass("simple");
      }
      target.add(target.find(".arrow")).toggleClass("dropped");
      return target.find(".arrow").addClass("mobile").html("]");
    };

    HeaderView.prototype.toggleMobileMegaNavTier = function(e) {
      var target;
      e.preventDefault();
      target = $(e.target).closest("li[data-expandable='true']");
      target.add(target.children(".arrow")).toggleClass("dropped");
      return target.children(".arrow").addClass("mobile").html("]");
    };

    return HeaderView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.TwitterView = (function(superClass) {
    extend(TwitterView, superClass);

    function TwitterView() {
      return TwitterView.__super__.constructor.apply(this, arguments);
    }

    TwitterView.prototype.initialize = function() {
      return this.fetchTweets();
    };

    TwitterView.prototype.fetchTweets = function() {
      var config, tweetLimit;
      tweetLimit = 3;
      ;
      config = {
        "id": "",
        "maxTweets": tweetLimit,
        "enableLinks": true,
        "showUser": true,
        "showTime": true,
        "showRetweet": false,
        "customCallback": this.renderTweets,
        "showInteraction": false
      };
      return twitterFetcher.fetch(config);
    };

    TwitterView.prototype.renderTweets = function(tweets) {
      var i, len, tweet, tweetWrapper;
      tweetWrapper = $(".twitter-tweets");
      if (tweets.length) {
        for (i = 0, len = tweets.length; i < len; i++) {
          tweet = tweets[i];
          tweetWrapper.append("<div class='twitter-tweet'>" + tweet + "</div>");
          tweetWrapper.find(".user").remove();
        }
        return tweetWrapper.find(".timePosted").addClass("accent-text").appendTo();
      } else {
        $("#twitter").remove();
        return console.log("No tweets to display. Most probable cause is an incorrectly entered Widget ID.");
      }
    };

    return TwitterView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.InstagramView = (function(superClass) {
    extend(InstagramView, superClass);

    function InstagramView() {
      return InstagramView.__super__.constructor.apply(this, arguments);
    }

    InstagramView.prototype.initialize = function() {
      var url;
      this.photoContainer = this.$(".instagram-photos");
      if (Theme.instagramShowTag && Theme.instagramTag.length) {
        url = "https://api.instagram.com/v1/tags/" + Theme.instagramTag + "/media/recent?access_token=" + Theme.instagramAccessToken + "&count=8&callback=";
      } else {
        url = "https://api.instagram.com/v1/users/self/media/recent?access_token=" + Theme.instagramAccessToken + "&count=8&callback=";
      }
      return $.ajax({
        type: "GET",
        dataType: "jsonp",
        url: url,
        success: (function(_this) {
          return function(response) {
            var i, len, photo, ref, results;
            if (response.meta.code === 200) {
              ref = response.data;
              results = [];
              for (i = 0, len = ref.length; i < len; i++) {
                photo = ref[i];
                results.push(_this.photoContainer.append("<a class='instagram-photo' target='_blank' href='" + photo.link + "'><img src='" + photo.images.low_resolution.url + "'/></a>"));
              }
              return results;
            } else {
              _this.$el.remove();
              return console.log("Instagram error: " + response.meta.error_message);
            }
          };
        })(this),
        error: (function(_this) {
          return function(response) {
            _this.$el.remove();
            return console.log("Instagram error: " + response.meta.error_message);
          };
        })(this)
      });
    };

    return InstagramView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.HomeView = (function(superClass) {
    extend(HomeView, superClass);

    function HomeView() {
      return HomeView.__super__.constructor.apply(this, arguments);
    }

    HomeView.prototype.initialize = function() {
      ;
      ;
      ;
      new ProductListView({
        el: this.$("#featured-products")
      });
      ;
      if (this.$(".slideshow").length) {
        return this.setupSlideshow();
      }
    };

    HomeView.prototype.setupSlideshow = function() {
      var slideshow;
      slideshow = new Flickity(".slideshow", {
        autoPlay: "5000" * 1,
        pageDots: false,
        imagesLoaded: true,
        contain: true,
        cellSelector: ".slide",
        wrapAround: true
      });
      this.$(".slideshow").imagesLoaded((function(_this) {
        return function() {
          return $(".flickity-viewport").height($(".flickity-slider .slide").eq(0).height());
        };
      })(this));
      return slideshow.on("cellSelect", (function(_this) {
        return function() {
          return $(".flickity-viewport").height($(".flickity-slider .slide").eq(slideshow.selectedIndex).height());
        };
      })(this));
    };

    return HomeView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.ProductListView = (function(superClass) {
    extend(ProductListView, superClass);

    function ProductListView() {
      return ProductListView.__super__.constructor.apply(this, arguments);
    }

    ProductListView.prototype.events = {
      "preload-images": "preloadImages"
    };

    ProductListView.prototype.initialize = function() {
      return this.preloadImages();
    };

    ProductListView.prototype.preloadImages = function(e, imageWrap) {
      var i, len, ref, results;
      ref = this.$(".product-item-image.is-loading");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        imageWrap = ref[i];
        results.push(this.showImage(imageWrap));
      }
      return results;
    };

    ProductListView.prototype.showImage = function(imageWrap) {
      var image;
      imageWrap = $(imageWrap);
      image = imageWrap.find("img");
      return imageWrap.imagesLoaded((function(_this) {
        return function() {
          if (image.height() < 100) {
            imageWrap.find(".product-details-overlay").addClass("landscape");
          }
          return imageWrap.removeClass("is-loading");
        };
      })(this));
    };

    return ProductListView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.CollectionView = (function(superClass) {
    extend(CollectionView, superClass);

    function CollectionView() {
      return CollectionView.__super__.constructor.apply(this, arguments);
    }

    CollectionView.prototype.events = {
      "click .click-to-load-button": "loadNewProducts",
      "change .collection-sort-filter select": "updateSortFilter",
      "change .collection-tag-filter select": "updateTagFilter"
    };

    CollectionView.prototype.initialize = function() {
      new ProductListView({
        el: this.$(".collection-content")
      });
      this.productList = this.$(".product-list");
      if (this.$("#content").hasClass("has-pagination") && (this.$("#content").hasClass("click-to-load") || this.$("#content").hasClass("infinite-scroll"))) {
        return this.initializeInfiniteScroll();
      }
    };

    CollectionView.prototype.initializeInfiniteScroll = function() {
      var behavior;
      this.clickToLoad = this.$(".click-to-load-button");
      this.currentProductsCount = this.$(".product-item").length;
      ;
      behavior = "twitter";
      ;
      return this.productList.infinitescroll({
        behavior: behavior,
        navSelector: "#pagination",
        nextSelector: "#pag-next a",
        itemSelector: ".product-item",
        loading: {
          finished: void 0,
          finishedMsg: "",
          img: "",
          msg: null,
          msgText: "",
          selector: null,
          speed: "fast",
          start: void 0,
          bufferPx: 200
        },
        errorCallback: (function(_this) {
          return function() {
            return _this.onProductsError();
          };
        })(this)
      }, (function(_this) {
        return function(newProducts) {
          return _this.onProductsLoad(newProducts);
        };
      })(this));
    };

    CollectionView.prototype.onProductsError = function() {
      return this.clickToLoad.removeClass("is-loading");
    };

    CollectionView.prototype.onProductsLoad = function(newProducts) {
      this.clickToLoad.removeClass("is-loading");
      this.productList.trigger("preload-images", [newProducts]);
      if (Theme.currencySwitcher) {
        $(".currency-switcher select").trigger("reset-currency");
      }
      this.currentProductsCount = this.currentProductsCount + $(newProducts).length;
      if (this.currentProductsCount === parseInt(this.productList.data("product-count"))) {
        this.clickToLoad.hide();
        return this.$(".collection-content").addClass("no-pagination");
      }
    };

    CollectionView.prototype.loadNewProducts = function(e) {
      this.productList.infinitescroll("retrieve");
      return this.$(e.target).addClass("is-loading");
    };

    CollectionView.prototype.updateSortFilter = function(e) {
      var Sorting, currentSearch, i, index, len, part, search, searchParts;
      Sorting = {};
      Sorting.sort_by = this.$(".collection-sort-filter select").val();
      if ($(e.target).closest(".collection-sorting").hasClass("vendor-collection")) {
        currentSearch = location.search;
        searchParts = currentSearch.split("&");
        for (index = i = 0, len = searchParts.length; i < len; index = ++i) {
          part = searchParts[index];
          if (part.indexOf("sort_by") !== -1) {
            searchParts.splice(index, 1);
          }
        }
        search = searchParts.join("&");
        return location.search = search + "&" + (jQuery.param(Sorting));
      } else {
        return location.search = jQuery.param(Sorting);
      }
    };

    CollectionView.prototype.updateTagFilter = function(e) {
      var collection, currentQuery, tag;
      collection = $(e.target).data("collection");
      tag = $(e.target).val();
      currentQuery = location.search;
      if (tag === "all") {
        return window.location.href = "/collections/" + collection + currentQuery;
      } else {
        return window.location.href = "/collections/" + collection + "/" + tag + currentQuery;
      }
    };

    return CollectionView;

  })(Backbone.View);

}).call(this);

(function() {
  ;

}).call(this);

(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.ProductView = (function(superClass) {
    extend(ProductView, superClass);

    function ProductView() {
      this.selectCallback = bind(this.selectCallback, this);
      return ProductView.__super__.constructor.apply(this, arguments);
    }

    ProductView.prototype.events = {
      "click #product-image-thumbnails img": "switchProductImage",
      "click #product-add input": "addToCart"
    };

    ProductView.prototype.initialize = function() {
      this.productId = this.$(".product-wrap").data("product-id");
      this.product = Theme.product;
      this.variants = this.product.variants;
      this.images = this.product.images;
      this.minimumPriceArea = this.$(".product-price-minimum");
      this.cacheImages();
      this.setupSelectors();
      this.addingToCart = false;
      ;
      new ProductListView({
        el: this.$("#related-products")
      });
      ;
      ;
      return Shopify.onError = (function(_this) {
        return function(XMLHttpRequest) {
          return _this.handleErrors(XMLHttpRequest);
        };
      })(this);
    };

    ProductView.prototype.switchCurrency = function(minimum, compare) {
      var attribute, i, len, ref;
      ref = this.minimumPriceArea[0].attributes;
      for (i = 0, len = ref.length; i < len; i++) {
        attribute = ref[i];
        if (attribute.name.indexOf("data-") > -1) {
          this.minimumPriceArea.attr(attribute.name, "");
        }
      }
      this.minimumPriceArea.attr("data-currency-" + Currency.currentCurrency, "").attr("data-currency-" + Theme.currency, Shopify.formatMoney(minimum, Theme.moneyFormat)).attr("data-currency", Theme.currency);
      this.$(".product-price-compare").attr("data-currency-" + Theme.currency, Shopify.formatMoney(compare, Theme.moneyFormat)).attr("data-currency", Theme.currency);
      return $(".currency-switcher").trigger("reset-currency");
    };

    ProductView.prototype.cacheImages = function() {
      return Shopify.Image.preload(this.images, "1024x1024");
    };

    ProductView.prototype.setupSelectors = function() {
      var i, len, optionSelectors, ref, variant;
      optionSelectors = new Shopify.OptionSelectors("product-variants", {
        product: this.product,
        onVariantSelected: this.selectCallback,
        enableHistoryState: true
      });
      optionSelectors.selectVariant(Theme.firstVariant);
      if (!(this.variants.length === 1 && (this.variants[0].title === "Default Title" || this.variants[0].title === "Default title"))) {
        this.$(".product-form").find(".product-options").addClass("visible");
        if (this.product.options.length === 1 && this.product.options[0] !== "Title") {
          this.$(".selector-wrapper").prepend("<label>" + this.product.options[0] + "</label>");
        }
      }
      ref = this.variants;
      for (i = 0, len = ref.length; i < len; i++) {
        variant = ref[i];
        if (variant.featured_image) {
          this.hasVariantImages = true;
          return;
        }
      }
    };

    ProductView.prototype.selectCallback = function(variant, selector) {
      var addToCartButton;
      addToCartButton = this.$("#product-add input");
      if (variant) {
        if (variant.available) {
          addToCartButton.val("Add").removeClass("disabled");
        } else {
          addToCartButton.val("Sold Out").addClass("disabled");
        }
        this.minimumPriceArea.html(Shopify.formatMoney(variant.price, Theme.moneyFormat));
        this.$(".product-price-compare").remove();
        if (variant.compare_at_price > variant.price) {
          this.minimumPriceArea.after("<span class='product-price-compare accent-text money' />");
          this.$(".product-price-compare").html(Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat));
        }
        if (Theme.currencySwitcher) {
          this.switchCurrency(variant.price, variant.compare_at_price);
        }
        if (this.hasVariantImages) {
          if (variant.featured_image) {
            this.switchProductImage(null, variant.featured_image);
          } else {
            this.$(".product-main-image img").attr("src", this.product.featured_image);
          }
        }
      } else {
        addToCartButton.val("Unavailable").addClass("disabled");
      }
      return this.$(".product-message-wrapper").remove();
    };

    ProductView.prototype.switchProductImage = function(e, newImage) {
      var originalImage;
      originalImage = this.$("#product-image-showcase img");
      this.$("#product-image-thumbnails li").removeClass("active");
      if (e) {
        this.$(e.target).parent().addClass("active");
        originalImage.attr("src", this.$(e.target).data("high-res"));
      } else {
        this.$(".product-thumbnail[data-image-position='" + (newImage.position - 1) + "']").addClass("active");
        Shopify.Image.switchImage(newImage, originalImage[0]);
      }
      return originalImage.trigger("prepare-zoom");
    };

    ProductView.prototype.addToCart = function(e) {
      var button;
      e.preventDefault();
      ;
      this.$(".product-message-wrapper").remove();
      if (this.addingToCart === true || this.$(".product-form").serialize() === "") {
        return false;
      }
      button = this.$("#product-add .action-btn");
      if (!button.hasClass("disabled")) {
        this.addingToCart = true;
        Shopify.addItemFromForm("product-form", (function(_this) {
          return function(item) {
            var message;
            message = "{{ product }} has been successfully added to your {{ cart_link }}. Feel free to {{ continue_link }} or {{ checkout_link }}.".replace("{{ product }}", "" + _this.product.title).replace("{{ cart_link }}", "<a href='/cart'>cart</a>").replace("{{ continue_link }}", "<a href='/collections/all'>Continue Shopping</a>").replace("{{ checkout_link }}", "<a href='/cart'>check out</a>");
            return setTimeout(function() {
              _this.$("#product-add-to-cart").append("<li class=\"product-message-wrapper\"><p class=\"product-message\">" + message + "</p></li>").addClass("success-message").removeClass("error-message");
              _this.addingToCart = false;
              return _this.updateCart();
            }, 500);
          };
        })(this));
      }
      ;
    };

    ProductView.prototype.updateCart = function() {
      return Shopify.getCart((function(_this) {
        return function(cart) {
          var cartCount, cartTotal;
          if (cart.item_count === 1) {
            cartCount = "1 item".replace("1", "" + cart.item_count);
          } else {
            cartCount = "0 items".replace("0", "" + cart.item_count);
          }
          $(".cart-item-count-wrap").text(cartCount);
          cartTotal = Shopify.formatMoney(cart.total_price, Theme.moneyFormat);
          $(".cart-amount-wrap").attr("data-currency-" + Currency.currentCurrency, "").attr("data-currency-" + Theme.currency, cart.total_price).attr("data-currency", Theme.currency).text(cartTotal);
          return $(".currency-switcher").trigger("reset-currency");
        };
      })(this));
    };

    ProductView.prototype.handleErrors = function(error) {
      var max, message, responseJSON, target, variant, variantID;
      responseJSON = $.parseJSON(error.responseText);
      if (responseJSON.message === "Cart Error") {
        variantID = parseInt(this.$("#product-variants").val(), 10);
        target = (function() {
          var i, len, ref, results;
          ref = this.product.variants;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            variant = ref[i];
            if (variant.id === variantID) {
              results.push(variant);
            }
          }
          return results;
        }).call(this);
        max = target[0].inventory_quantity;
        message = "Unable to add more than {{ stock }} to your cart.".replace("{{ stock }}", max);
      } else {
        message = "We were unable to add this product to your cart. Please try again later. Contact us if you continue to have issues.";
      }
      return setTimeout((function(_this) {
        return function() {
          _this.$("#product-add-to-cart").append("<li class=\"product-message-wrapper\"><p class=\"product-message\">" + message + "</p></li>").addClass("error-message").removeClass("success-message");
          return _this.addingToCart = false;
        };
      })(this), 1000);
    };

    return ProductView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.RTEView = (function(superClass) {
    extend(RTEView, superClass);

    function RTEView() {
      return RTEView.__super__.constructor.apply(this, arguments);
    }

    RTEView.prototype.events = {
      "click .tabs li": "switchTabs"
    };

    RTEView.prototype.initialize = function() {
      this.setupTabs();
      return this.$el.fitVids();
    };

    RTEView.prototype.switchTabs = function(e) {
      var content, position, tab, tabContainer, tabContentContainer;
      tab = $(e.currentTarget);
      tabContainer = tab.parent();
      tabContentContainer = tabContainer.next();
      position = tab.index();
      content = tabContentContainer.find("> li").eq(position);
      tabContainer.find("> li").add(tabContentContainer.find("> li")).removeClass("active");
      return tab.add(content).addClass("active");
    };

    RTEView.prototype.setupTabs = function() {
      var tabs;
      tabs = this.$el.find(".tabs");
      return tabs.find("li:first").add(tabs.next().find("li:first")).addClass("active");
    };

    return RTEView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.SelectView = (function(superClass) {
    extend(SelectView, superClass);

    function SelectView() {
      return SelectView.__super__.constructor.apply(this, arguments);
    }

    SelectView.prototype.events = {
      "change": "updateSelectText"
    };

    SelectView.prototype.initialize = function() {
      if (!(this.$el.parent(".select-wrapper").length || this.$el.hasClass("product-variants"))) {
        this.$el.wrap("<div class='select-wrapper' />").parent().prepend("<span class='selected-text'></span>");
      }
      this.updateSelectText();
      if (!this.$el.hasClass("product-variants")) {
        this.$el.show();
      }
      return $("#address-country").on("change", (function(_this) {
        return function() {
          return _this.updateSelectText("province");
        };
      })(this));
    };

    SelectView.prototype.updateSelectText = function(select) {
      var newOption, target;
      if (select === "province") {
        target = $("#address-province");
      } else {
        target = this.$el;
      }
      newOption = target.find("option:selected").text() || target.find("option").eq(0).val();
      return target.siblings(".selected-text").text(newOption);
    };

    return SelectView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.ShareView = (function(superClass) {
    extend(ShareView, superClass);

    function ShareView() {
      return ShareView.__super__.constructor.apply(this, arguments);
    }

    ShareView.prototype.events = {
      "click": "closeShare",
      "click .share-widget-toggle": "openShare"
    };

    ShareView.prototype.openShare = function(e) {
      var otherShareWidgets, targetShareWidget;
      targetShareWidget = this.$(e.target).closest(".article-meta-wrap");
      otherShareWidgets = $(".article-meta-wrap").not(targetShareWidget);
      targetShareWidget.addClass("active");
      return otherShareWidgets.removeClass("active");
    };

    ShareView.prototype.closeShare = function(e) {
      if (!(this.$(e.target).closest(".share-widget-toggle").length || this.$(e.target).closest(".share-widget").length)) {
        return $(".article-meta-wrap").removeClass("active");
      }
    };

    return ShareView;

  })(Backbone.View);

}).call(this);

(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.QuickShopView = (function(superClass) {
    extend(QuickShopView, superClass);

    function QuickShopView() {
      this.selectCallback = bind(this.selectCallback, this);
      return QuickShopView.__super__.constructor.apply(this, arguments);
    }

    QuickShopView.prototype.events = {
      "click .product-item-quick-shop .available": "openQuickShop",
      "click .quick-shop-modal": "closeQuickShop",
      "click .quick-shop-add": "addToCart",
      "click .quick-shop-close": "closeQuickShop"
    };

    QuickShopView.prototype.initialize = function() {
      this.quickShopModal = $(".quick-shop-modal");
      this.quickShopContainer = $(".quick-shop-container");
      this.quickShopConfirmation = this.$(".quick-shop-confirmation");
      this.minimumPriceArea = this.$(".quick-shop-price-minimum");
      this.addingToCart = false;
      this.transitionend = (function(transition) {
        var transEndEventNames;
        transEndEventNames = {
          "-webkit-transition": "webkitTransitionEnd",
          "-moz-transition": "transitionend",
          transition: "transitionend"
        };
        return transEndEventNames[transition];
      })(Modernizr.prefixed("transition"));
      return Shopify.onError = (function(_this) {
        return function(XMLHttpRequest) {
          return _this.handleErrors(XMLHttpRequest);
        };
      })(this);
    };

    QuickShopView.prototype.openQuickShop = function(e) {
      var firstVariant, i, len, ref, select, target;
      target = $(e.target);
      this.product = target.data("product-json");
      firstVariant = target.data("first-variant");
      this.setupProductDetails(this.product, firstVariant);
      this.setupSelectors(this.product, firstVariant);
      ref = this.$("select");
      for (i = 0, len = ref.length; i < len; i++) {
        select = ref[i];
        new SelectView({
          el: select
        });
      }
      this.quickShopModal.addClass("visible");
      setTimeout((function(_this) {
        return function() {
          _this.quickShopModal.addClass("active");
          return $(document.body).addClass("quick-shop-open");
        };
      })(this), 20);
      return this.positionQuickShop();
    };

    QuickShopView.prototype.closeQuickShop = function(e, confirm, hasError) {
      if (e) {
        if (!(this.$(e.target).closest(".quick-shop-container").length || this.$(e.target).closest(".product-item-quick-shop").length)) {
          this.quickShopModal.removeClass("active").one(this.transitionend, (function(_this) {
            return function() {
              _this.quickShopModal.removeClass("visible");
              _this.quickShopConfirmation.removeClass("active");
              _this.quickShopContainer.empty();
              $(document.body).removeClass("quick-shop-open");
              _this.addingToCart = false;
              if (hasError === "remove error") {
                return _this.$(".quick-shop-message").remove();
              }
            };
          })(this));
        }
      }
      if (confirm) {
        return this.quickShopContainer.removeClass("active").one(this.transitionend, (function(_this) {
          return function() {
            return _this.quickShopConfirmation.addClass("active");
          };
        })(this));
      }
    };

    QuickShopView.prototype.setupProductDetails = function(product, firstVariant) {
      var i, itemCompareAtPrice, itemPrice, len, ref, results, variant, variantPrice;
      itemPrice = Shopify.formatMoney(firstVariant.price, Theme.moneyFormat);
      itemCompareAtPrice = "";
      if (firstVariant.compare_at_price > firstVariant.price) {
        itemCompareAtPrice = Shopify.formatMoney(firstVariant.compare_at_price, Theme.moneyFormat);
      }
      this.quickShopContainer.append("<h2 class=\"quick-shop-title\">" + product.title + "</h2>\n<form class=\"product-form\" action=\"/cart/add\" method=\"post\" id=\"product-form-" + product.id + "\">\n    <div class=\"quick-shop-variants-container\">\n        <select class=\"product-variants\" name=\"id\" id=\"quick-shop-variants-" + product.id + "\"></select>\n    </div>\n    <div class=\"quick-shop-price-container accent-text\">\n        <span class=\"quick-shop-price-minimum money\">" + itemPrice + "</span>\n        <span class=\"quick-shop-price-compare money\">" + itemCompareAtPrice + "</span>\n    </div>\n    <input class=\"quick-shop-add action-btn accent-text\" type=\"submit\" value=\"Add\">\n</form>").data("product-json", product);
      ref = product.variants;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        variant = ref[i];
        variantPrice = Shopify.formatMoney(variant.price, Theme.moneyFormat);
        results.push(this.$(".product-variants").append("<option value='" + variant.id + "' data-sku='" + variant.sku + "'>" + variant.title + " - " + variantPrice + "</option>"));
      }
      return results;
    };

    QuickShopView.prototype.setupSelectors = function(product, firstVariant) {
      var i, index, len, option, optionSelectors, ref, results;
      optionSelectors = new Shopify.OptionSelectors("quick-shop-variants-" + product.id, {
        product: product,
        onVariantSelected: this.selectCallback,
        enableHistoryState: false
      });
      optionSelectors.selectVariant(firstVariant.id);
      if (product.variants.length === 1 && (product.variants[0].title === "Default" || product.variants[0].title === "Default")) {
        this.quickShopContainer.find(".quick-shop-variants-container").addClass("no-options");
      } else if (product.options.length === 1) {
        this.$(".selector-wrapper").prepend("<label>" + product.options[0] + "</label>");
      }
      this.$(".selector-wrapper label").remove();
      ref = product.options;
      results = [];
      for (index = i = 0, len = ref.length; i < len; index = ++i) {
        option = ref[index];
        results.push(this.$(".selector-wrapper").eq(index).prepend("<label>" + product.options[index] + "</label>"));
      }
      return results;
    };

    QuickShopView.prototype.selectCallback = function(variant, selector) {
      var addToCartButton, minimumPriceArea, quickShopMessage;
      addToCartButton = this.$(".quick-shop-add");
      minimumPriceArea = this.$(".quick-shop-price-minimum");
      if (variant) {
        if (variant.available) {
          addToCartButton.val("Add").removeClass("disabled");
        } else {
          addToCartButton.val("Sold Out").addClass("disabled");
        }
        minimumPriceArea.html(Shopify.formatMoney(variant.price, Theme.moneyFormat));
        this.$(".quick-shop-price-compare").remove();
        if (variant.compare_at_price > variant.price) {
          minimumPriceArea.after("<span class='quick-shop-price-compare money' />");
          this.$(".quick-shop-price-compare").html(Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat));
        }
        if (Theme.currencySwitcher) {
          this.switchCurrency(variant.price, variant.compare_at_price);
        }
      } else {
        addToCartButton.val("Unavailable").addClass("disabled");
      }
      quickShopMessage = this.$(".quick-shop-message");
      if (quickShopMessage.length) {
        return quickShopMessage.remove();
      }
    };

    QuickShopView.prototype.switchCurrency = function(minimum, compare) {
      var attribute, i, len, minimumPriceArea, ref;
      minimumPriceArea = this.$(".quick-shop-price-minimum");
      ref = minimumPriceArea[0].attributes;
      for (i = 0, len = ref.length; i < len; i++) {
        attribute = ref[i];
        if (attribute.name.indexOf("data-") > -1) {
          minimumPriceArea.attr(attribute.name, "");
        }
      }
      minimumPriceArea.attr("data-currency-" + Currency.currentCurrency, "").attr("data-currency-" + Theme.currency, Shopify.formatMoney(minimum, Theme.moneyFormat)).attr("data-currency", Theme.currency);
      this.$(".quick-shop-price-compare").attr("data-currency-" + Theme.currency, Shopify.formatMoney(compare, Theme.moneyFormat)).attr("data-currency", Theme.currency);
      return $(".currency-switcher").trigger("reset-currency");
    };

    QuickShopView.prototype.addToCart = function(e) {
      var button, product, productID;
      product = this.quickShopContainer.data("product-json");
      productID = product.id;
      if (this.addingToCart === true || $("#product-form-" + productID).serialize() === "") {
        return false;
      }
      e.preventDefault();
      button = this.$(".quick-shop-add");
      if (!button.children().hasClass("disabled")) {
        this.addingToCart = true;
        return Shopify.addItemFromForm("product-form-" + productID, (function(_this) {
          return function(item) {
            _this.updateCart(item);
            return _this.closeQuickShop(null, true);
          };
        })(this));
      }
    };

    QuickShopView.prototype.updateCart = function(item) {
      return Shopify.getCart((function(_this) {
        return function(cart) {
          var cartCount, newFormattedAmount;
          if (cart.item_count === 1) {
            cartCount = "1 item".replace("1", "" + cart.item_count);
          } else {
            cartCount = "0 items".replace("0", "" + cart.item_count);
          }
          newFormattedAmount = Shopify.formatMoney(cart.total_price, "");
          _this.$(".cart-item-count-wrap").text(cartCount);
          _this.$(".cart-amount-wrap").attr("data-currency-" + Currency.currentCurrency, "").attr("data-currency-" + Theme.currency, cart.total_price).attr("data-currency", Theme.currency).html(newFormattedAmount);
          if (Theme.currencySwitcher) {
            return $(".currency-switcher").trigger("reset-currency");
          }
        };
      })(this));
    };

    QuickShopView.prototype.positionQuickShop = function() {
      var quickShopConfirmationHeight, quickShopHeight;
      quickShopHeight = this.quickShopContainer.outerHeight();
      this.quickShopContainer.css({
        marginTop: quickShopHeight / -2
      }).addClass("active");
      quickShopConfirmationHeight = this.quickShopConfirmation.outerHeight();
      return this.quickShopConfirmation.css({
        marginTop: quickShopConfirmationHeight / -2
      });
    };

    QuickShopView.prototype.handleErrors = function(error) {
      var max, message, target, variant, variantID;
      error = $.parseJSON(error.responseText);
      if (error.message === "Cart Error") {
        variantID = parseInt(this.$("#quick-shop-variants-" + this.product.id).val(), 10);
        target = (function() {
          var i, len, ref, results;
          ref = this.product.variants;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            variant = ref[i];
            if (variant.id === variantID) {
              results.push(variant);
            }
          }
          return results;
        }).call(this);
        max = target[0].inventory_quantity;
        message = "Unfortunately, we only have {{ stock }} in stock.".replace("{{ stock }}", max);
      } else {
        message = "We were unable to add this product to your cart. Please try again later. Contact us if you continue to have issues.";
      }
      this.quickShopContainer.append("<div class='quick-shop-message'>" + message + "</div>");
      return setTimeout((function(_this) {
        return function() {
          _this.closeQuickShop(null, null, "remove error");
          return _this.addingToCart = false;
        };
      })(this), 1000);
    };

    return QuickShopView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.CurrencyView = (function(superClass) {
    extend(CurrencyView, superClass);

    function CurrencyView() {
      return CurrencyView.__super__.constructor.apply(this, arguments);
    }

    CurrencyView.prototype.events = {
      "change [name=currencies]": "convertAll",
      "switch-currency": "switchCurrency",
      "reset-currency": "resetCurrency"
    };

    CurrencyView.prototype.initialize = function() {
      var cents, doubleMoney, i, j, len, len1, money, ref, ref1;
      Currency.format = Theme.currencySwitcherFormat;
      Currency.money_with_currency_format = {};
      Currency.money_with_currency_format[Theme.currency] = Theme.moneyFormatCurrency;
      Currency.money_format = {};
      Currency.money_format[Theme.currency] = Theme.moneyFormat;
      this.defaultCurrency = "USD";
      this.cookieCurrency = Currency.cookie.read();
      if (this.cookieCurrency) {
        this.$("[name=currencies]").val(this.cookieCurrency);
      }
      ref = $("span.money span.money");
      for (i = 0, len = ref.length; i < len; i++) {
        doubleMoney = ref[i];
        $(doubleMoney).parents("span.money").removeClass("money");
      }
      ref1 = $("span.money");
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        money = ref1[j];
        $(money).data("currency-" + Theme.currency, $(money).html());
        if (Currency.format === "money_with_currency_format") {
          cents = parseInt($(money).html().replace(/[^0-9]/g, ''), 10);
          $(money).html(Shopify.formatMoney(cents, Theme.moneyFormat));
        }
      }
      this.switchCurrency();
      return this.$(".selected-currency").text(Currency.currentCurrency);
    };

    CurrencyView.prototype.resetCurrency = function() {
      return Currency.convertAll(Theme.currency, this.$("[name=currencies]").val());
    };

    CurrencyView.prototype.switchCurrency = function() {
      if (this.cookieCurrency === null) {
        if (Theme.currency !== this.defaultCurrency) {
          return Currency.convertAll(Theme.currency, this.defaultCurrency);
        } else {
          return Currency.currentCurrency = this.defaultCurrency;
        }
      } else if (this.$("[name=currencies]").size() && this.$("[name=currencies] option[value=" + this.cookieCurrency + "]").size() === 0) {
        Currency.currentCurrency = Theme.currency;
        return Currency.cookie.write(Theme.currency);
      } else if (this.cookieCurrency === Theme.currency) {
        return Currency.currentCurrency = Theme.currency;
      } else {
        return Currency.convertAll(Theme.currency, this.cookieCurrency);
      }
    };

    CurrencyView.prototype.convertAll = function(e, variant, selector) {
      var newCurrency;
      newCurrency = $(e.target).val();
      Currency.convertAll(Currency.currentCurrency, newCurrency);
      this.$(".selected-currency").text(Currency.currentCurrency);
      return this.cookieCurrency = newCurrency;
    };

    return CurrencyView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.FooterView = (function(superClass) {
    extend(FooterView, superClass);

    function FooterView() {
      return FooterView.__super__.constructor.apply(this, arguments);
    }

    FooterView.prototype.initialize = function() {
      this.copyright = this.$(".footer-module.copyright");
      return $(window).on("resize", (function(_this) {
        return function() {
          if (document.documentElement.offsetWidth > 767 && _this.copyright.hasClass("block-module")) {
            return _this.positionCopyrightModule("large");
          } else if (document.documentElement.offsetWidth <= 767 && _this.copyright.hasClass("inline-module")) {
            return _this.positionCopyrightModule("medium");
          }
        };
      })(this)).trigger("resize");
    };

    FooterView.prototype.positionCopyrightModule = function(breakpoint) {
      var footerModuleWrapper;
      footerModuleWrapper = this.$(".footer-module-wrapper");
      this.copyright.toggleClass("inline-module block-module");
      if (breakpoint === "large") {
        return footerModuleWrapper.prepend(this.copyright);
      } else if (breakpoint === "medium") {
        return footerModuleWrapper.append(this.copyright);
      }
    };

    return FooterView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.PasswordView = (function(superClass) {
    extend(PasswordView, superClass);

    function PasswordView() {
      return PasswordView.__super__.constructor.apply(this, arguments);
    }

    PasswordView.prototype.events = {
      'click': 'closeModal',
      'click .admin-login-modal': 'openModal'
    };

    PasswordView.prototype.initialize = function() {
      this.modalWrapper = $('.password-page-modal-wrapper');
      this.modalContent = this.modalWrapper.find('.password-page-modal');
      this.openByDefault = this.modalWrapper.find('[data-open-modal]').length;
      if (this.openByDefault) {
        this.openModal();
      }
      return $(window).resize((function(_this) {
        return function() {
          return _this.positionModal();
        };
      })(this));
    };

    PasswordView.prototype.closeModal = function(e) {
      if (this.$(e.target).hasClass('visible')) {
        return this.modalWrapper.removeClass("visible").one("trend", (function(_this) {
          return function() {
            return _this.$el.removeClass("scroll-locked");
          };
        })(this));
      }
    };

    PasswordView.prototype.openModal = function() {
      this.$el.addClass("scroll-locked");
      this.positionModal();
      return this.modalWrapper.addClass("visible");
    };

    PasswordView.prototype.positionModal = function() {
      return this.modalContent.css({
        marginTop: -(this.modalContent.outerHeight() / 2),
        marginLeft: -(this.modalContent.outerWidth() / 2)
      });
    };

    return PasswordView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.GiftCardView = (function(superClass) {
    extend(GiftCardView, superClass);

    function GiftCardView() {
      return GiftCardView.__super__.constructor.apply(this, arguments);
    }

    GiftCardView.prototype.initialize = function() {
      return this.addQrCode();
    };

    GiftCardView.prototype.addQrCode = function() {
      var qrWrapper;
      qrWrapper = $('[data-qr-code]');
      return new QRCode(qrWrapper[0], {
        text: qrWrapper.data('qr-code'),
        width: 120,
        height: 120
      });
    };

    return GiftCardView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.ThemeView = (function(superClass) {
    extend(ThemeView, superClass);

    function ThemeView() {
      return ThemeView.__super__.constructor.apply(this, arguments);
    }

    ThemeView.prototype.el = document.body;

    ThemeView.prototype.initialize = function() {
      var body;
      body = $(document.body);
      this.isHome = body.hasClass("template-index");
      this.isProduct = body.hasClass("template-product");
      this.isCollection = body.hasClass("template-collection");
      this.isSearch = body.hasClass("template-search");
      this.isPasswordPage = body.hasClass("template-password");
      this.isGiftCardPage = body.hasClass("gift-card-template");
      this.hasArticle = body.find(".article-meta-wrap");
      return this.isltIE10 = $("html").hasClass("lt-ie10");
    };

    ThemeView.prototype.render = function() {
      var i, j, len, len1, ref, ref1, rte, select;
      new HeaderView({
        el: $(".main-header")
      });
      new FooterView({
        el: $(".main-footer")
      });
      ref = $(".rte");
      for (i = 0, len = ref.length; i < len; i++) {
        rte = ref[i];
        new RTEView({
          el: rte
        });
      }
      if (Theme.currencySwitcher) {
        new CurrencyView({
          el: this.$(".currency-switcher")
        });
      }
      if (this.isHome) {
        new HomeView({
          el: this.$el
        });
      }
      if (this.isCollection) {
        new CollectionView({
          el: this.$el
        });
      }
      if (this.isProduct) {
        new ProductView({
          el: this.$el
        });
      }
      if (this.isSearch) {
        new ProductListView({
          el: $("#search-results")
        });
      }
      if (this.hasArticle) {
        new ShareView({
          el: this.$el
        });
      }
      if (this.isPasswordPage) {
        new PasswordView({
          el: this.$el
        });
      }
      if (this.isGiftCardPage) {
        new GiftCardView();
      }
      new QuickShopView({
        el: this.$el
      });
      ref1 = $("select");
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        select = ref1[j];
        new SelectView({
          el: select
        });
      }
      if (this.isltIE10) {
        return this.inputPlaceholderFix();
      }
    };

    ThemeView.prototype.inputPlaceholderFix = function() {
      var i, input, len, placeholders, text;
      placeholders = $("[placeholder]");
      for (i = 0, len = placeholders.length; i < len; i++) {
        input = placeholders[i];
        input = $(input);
        if (!(input.val().length > 0)) {
          text = input.attr("placeholder");
          input.attr("value", text);
          input.data("original-text", text);
        }
      }
      placeholders.focus(function() {
        input = $(this);
        if (input.val() === input.data("original-text")) {
          return input.val('');
        }
      });
      return placeholders.blur(function() {
        input = $(this);
        if (input.val().length === 0) {
          return input.val(input.data("original-text"));
        }
      });
    };

    return ThemeView;

  })(Backbone.View);

  $(function() {
    window.theme = new ThemeView();
    return theme.render();
  });

}).call(this);
